import * as React from 'react';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';

import { CreditRequestModel } from '../../models/credit-request';

export interface ICashCustomerBankDetailsProps {
  model: CreditRequestModel;
  disabled: boolean;
}

@observer
export class CashCustomerBankDetails extends React.Component<ICashCustomerBankDetailsProps> {
  public render() {
    const { model, disabled } = this.props;
    return (
      <Grid container className="section">
        <Grid item xs={1} />
        <Grid item xs={10}>
          <h2>Customer Bank Account Details</h2>
          <p className="cash-customer-only-note">Cash customer only</p>
          <p>Bank details are not captured in this workflow yet.</p>
          <Grid container spacing={16} className="cash-bank-details">
            <Grid item xs={12} md={4}>
              <TextField id="cash-customer-name-of-account" label="Name of Account" value="" disabled fullWidth />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField id="cash-customer-bsb" label="BSB" value="" disabled fullWidth />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField id="cash-customer-account-number" label="Account Number" value="" disabled fullWidth />
            </Grid>
            <Grid item xs={12}>
              <p className="required-yes-no-label">Checked verbally with account holder?</p>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.cashCustomerAccountCheckedVerbally === true}
                    disabled={disabled}
                    onChange={() => model.update('cashCustomerAccountCheckedVerbally', true)}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.cashCustomerAccountCheckedVerbally === false}
                    disabled={disabled}
                    onChange={() => model.update('cashCustomerAccountCheckedVerbally', false)}
                  />
                }
                label="No"
              />
              {model.errors.cashCustomerAccountCheckedVerbally && (
                <p className="required-answer">
                  {model.errors.cashCustomerAccountCheckedVerbally}
                </p>
              )}
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="cash-customer-account-checked-by"
                label="By whom / Signature"
                value={model.cashCustomerAccountCheckedBy}
                disabled={disabled}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  model.update('cashCustomerAccountCheckedBy', event.currentTarget.value)
                }
                error={!!model.errors.cashCustomerAccountCheckedBy}
                helperText={model.errors.cashCustomerAccountCheckedBy || null}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
